import { render, staticRenderFns } from "./StatisticsView.vue?vue&type=template&id=10a5b0b2&scoped=true"
import script from "./StatisticsView.vue?vue&type=script&lang=js"
export * from "./StatisticsView.vue?vue&type=script&lang=js"
import style0 from "./StatisticsView.vue?vue&type=style&index=0&id=10a5b0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a5b0b2",
  null
  
)

export default component.exports